/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let totalCountURL = root.memberFiltersTotalCountUrl.link;
let memberFiltersForSignUpApiURL = root.memberFiltersForSignUpApiUrl.link;
let memberConnectedUsersApiUrl = root.memberConnectedUsersApiUrl.link;
let connectedMemberCountApiUrl = root.connectedMemberCountApiUrl.link;
let userOnlineTimeCountApiUrl = root.userOnlineTimeCountApiUrl.link;
let allUserOnlineTimeCountApiUrl = root.allUserOnlineTimeCountApiUrl.link;
let connectedMemberSearchKeyURL = root.connectedMemberSearchKeyUrl.link;

export default {
  state: {
    getMemberFilterCountState:{},
    memberConnectedUsersListState:{},
    getConnectedMemberCountState:{},
    getUserOnlineTimeCountState:{},
    getAllUserOnlineTimeCountState:{}
  },
  mutations: {
    getMemberFilterCountMutation(state, value) {
      Vue.set(state, 'getMemberFilterCountState', value);
    },
    getConnectedMemberCountMutation(state, value) {
      Vue.set(state, 'getConnectedMemberCountState', value);
    },
    memberConnectedUsersListMutation(state, value) {
      Vue.set(state, 'memberConnectedUsersListState', value);
    },
    getUserOnlineTimeCountMutation(state, value) {
      Vue.set(state, 'getUserOnlineTimeCountState', value);
    },
    getAllUserOnlineTimeCountMutation(state, value) {
      Vue.set(state, 'getAllUserOnlineTimeCountState', value);
    },
  },
  actions: {
    // Member Connected User Search Function
    memberConnectedUserSearchFun(context,payload){
      return new Promise ((resolve, reject) => {
         axios.post(connectedMemberSearchKeyURL, payload).then((res)=>{
          resolve(res);
         }).catch((err)=>{
          reject(err);
         })
      })
    },
    // Get All User Online Time Count Method
    getAllUserOnlineTimeCountApiUrlFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allUserOnlineTimeCountApiUrl).then(res => {
              context.commit('getAllUserOnlineTimeCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get User Online Time Count Method
    getUserOnlineTimeCountApiUrlFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(userOnlineTimeCountApiUrl + payload.id + '/').then(res => {
              context.commit('getUserOnlineTimeCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Connected Member Filter Count
    getConnectedMemberCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(connectedMemberCountApiUrl, payload).then(res => {
              context.commit('getConnectedMemberCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Filter Count
    getMemberFilterCountFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(totalCountURL, payload).then(res => {
              context.commit('getMemberFilterCountMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get All Member Filter For Signup
    getMemberFilterListForSignupFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersForSignUpApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Connnected Users List
    memberConnectedUsersListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberConnectedUsersApiUrl, payload).then(res => {
              context.commit('memberConnectedUsersListMutation', res);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getMemberFilterCountGetters: state => state.getMemberFilterCountState,
    memberConnectedUsersListGetters: state => state.memberConnectedUsersListState,
    getConnectedMemberCountGetters: state => state.getConnectedMemberCountState,
    getUserOnlineTimeCountGetters: state => state.getUserOnlineTimeCountState,
    getAllUserOnlineTimeCountGetters: state => state.getAllUserOnlineTimeCountState
  }
}